import { render, staticRenderFns } from "./RelatVendas.vue?vue&type=template&id=3dc6b2d0&"
import script from "./RelatVendas.vue?vue&type=script&lang=js&"
export * from "./RelatVendas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports